import { Block } from 'baseui/block';
// types 
import { ISP_HeatingGenerator } from './types'
// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { SmallPanel as ValveVarPanel, schema as schemaValveVar } from '../../Devices/ValveVar'
import { SmallPanel as BelimoPanel, schema as schemaBelimo } from '../../Devices/BelimoEnergyValve'
import { SmallPanel as ValvePanel, schema as schemaValve } from '../../Devices/ValveTwoPoint'
import { SmallPanel as PumpOneSpeedPanel, schemaPump, schemaPump1, schemaPump2 } from '../../Devices/DriveOneSpeed'
import { schemaPump as schemaPumpVar, schemaPump1 as schemaPump1Var, schemaPump2 as schemaPump2Var } from '../../Devices/DriveVarSpeed'
import { LoadingView } from "../../../components";
// api
import { themedUseStyletron } from '../../../theme/customTheme'
import { IconHeatGeneration } from './IconHeatGeneration';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { FormattedMessage } from 'react-intl';
import { LabelLarge } from 'baseui/typography';
import { HeatingCoil3D } from '../SP_HeatingCoil/HeatingCoil3D';
import { useMemo } from 'react';
import { IAutomationObject } from '../../types';
import { Badge } from 'baseui/badge';

export function OverviewPanel(props: ISP_HeatingGenerator) {
        const [, theme] = themedUseStyletron();
        const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

        const valvevar = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaValveVar), [children]);
        const belimo = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaBelimo), [children]);
        const valve = useMemo(() => children?.find((v: IAutomationObject) => v.schema === schemaValve), [children]);
        const pumps = useMemo(() => children?.filter((v: IAutomationObject) => v.schema === schemaPump || v.schema === schemaPump1 || v.schema === schemaPump2
                || v.schema === schemaPumpVar || v.schema === schemaPump1Var || v.schema === schemaPump2Var
        ), [children]);

        return (
                <OverviewPanelWrapper includeAlarmsFromChildren {...props} icon={<IconHeatGeneration color={theme.colors.backgroundPrimary}></IconHeatGeneration>}>
                        <HeatingCoil3D active={props.isOn} width={100} height={100}></HeatingCoil3D>
                        {props.isOn && <Badge hierarchy='secondary' color='negative' content={<FormattedMessage id="SubPlants.HEATING" defaultMessage="HEATING" />} />}
                        {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="Off" />} />}
                        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                                <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='5px'>
                                        {pumps?.map((item: any, index: number) => (
                                                <PumpOneSpeedPanel {...item}></PumpOneSpeedPanel>
                                        ))}
                                        {valvevar &&
                                                <ValveVarPanel {...valvevar}></ValveVarPanel>
                                        }
                                        {belimo &&
                                                <BelimoPanel {...belimo}></BelimoPanel>
                                        }
                                        {valve &&
                                                <ValvePanel {...valve}></ValvePanel>
                                        }
                                </Block>
                        </LoadingView>
                </OverviewPanelWrapper>
        );
}